import { Icon } from '@pepsico-ds/ui'

function SimpleProfileDropdown({ onLogout }) {
  return (
    <div className="absolute right-0 mr-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
      {/* Rotated box pointer */}
      <div className="absolute top-[-5px] right-8">
        <div className="w-3 h-3 absolute bg-white -z-10" style={{ rotate: '45deg' }} />
      </div>

      <div className="py-1 -z-40">
        <button
          type="button"
          onClick={onLogout}
          className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
        >
          <Icon icon="logout" size="small" />
          Logout
        </button>
      </div>
    </div>
  )
}

export default SimpleProfileDropdown
